
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReleaseStatusBadge",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
});
